// Lazy doors to the heavy PDF engines. The generators import these tiny
// loaders instead of the libraries themselves, so jspdf and pdfjs-dist ride
// in their own chunks, fetched on first use and cached by the module system.
// (stubImport.js already lazy-loads pdfjs the same way.)

let _pdfjs = null;
export const loadPdfJs = async () => {
  if (!_pdfjs) {
    _pdfjs = await import("pdfjs-dist");
    _pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${_pdfjs.version}/build/pdf.worker.min.mjs`;
  }
  return _pdfjs;
};

let _jspdf = null;
export const loadJsPDF = async () => _jspdf || (_jspdf = (await import("jspdf")).jsPDF);
